import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=7c1a5e06&"
import script from "./RecordDetails.vue?vue&type=script&lang=js&"
export * from "./RecordDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports